import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { PropTypes } from 'prop-types';

import { Item } from './styles';
import Dropdown from '@spa/shared/components/Dropdown';
import { GUEST_DROPDOWN_ITEMS } from '@spa/shared/components/Header/Desktop/tabs/guestLinksData';
import LanguageSelector from '@spa/shared/components/LanguageSelector';
import Hamburger from '@spa/shared/svg/hamburger';
import events from '@spa/shared/hooks/tracking/events';
import { trackAmplitude } from '@spa/shared/hooks/tracking/services/amplitude/dataAmplitude';

const UnauthenticatedMenu = ({ changeLanguageHandler, hideHamburgerMenu }) => {
  const { t } = useTranslation('header');
  const { locale } = useRouter();
  const { pathname } = useRouter();

  const isResidences = pathname.includes('/residences');
  const signupURL = isResidences ? '/signup?from=uniresidences' : '/signup';
  const isSignupOrLogin = pathname.includes('/signup') || pathname.includes('/login');

  const handleClick = ({ link }) => {
    link && link === '/signup'
      ? trackAmplitude(events.viewSignupPage, { origin: 'hamburger menu' })
      : trackAmplitude(events.viewSignupPage, { origin: pathname });
  };

  return (
    <React.Fragment>
      {!isSignupOrLogin && (
        <React.Fragment>
          <Item>
            <Link href={signupURL} locale={locale} prefetch={false} onClick={handleClick}>
              {t('header:Sign up')}
            </Link>
          </Item>
          <Item>
            <Link href="/login" locale={locale} prefetch={false}>
              {t('header:Log in')}
            </Link>
          </Item>
        </React.Fragment>
      )}
      <Item className={isSignupOrLogin ? 'checkout-signup' : ''}>
        <LanguageSelector onSelect={changeLanguageHandler} />
      </Item>
      {hideHamburgerMenu ? null : (
        <Item>
          <Dropdown
            id={'usermenu'}
            values={GUEST_DROPDOWN_ITEMS.map(({ key, href, link, separator, target }) => {
              return {
                key,
                href,
                link,
                translation: t(`${key}`),
                separator,
                target,
                onClick: () => handleClick({ link })
              };
            })}
            selected={''}
            onSelect={() => {}}
            Icon={Hamburger}
          />
        </Item>
      )}
    </React.Fragment>
  );
};

UnauthenticatedMenu.propTypes = {
  changeLanguageHandler: PropTypes.func.isRequired,
  hideHamburgerMenu: PropTypes.bool
};

export default UnauthenticatedMenu;
